import React, { useState, useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom"; 
import CourseItem from "./CourseItem";
import CoursesService from "../../services/CoursesService";
import "./CourseItem.css";

const Courses = () => {
  const [courses, setCourses] = useState([]);
  const [isLogin, setIsLogin] = useState(false);
  const navigate = useNavigate();

  // useEffect(() => {
  //   CoursesService.getAllCourses()
  //     .then((response) => response.json())
  //     .then((data) => {
  //       // console.log(data);
  //       setCourses(data?.course?.course);
  //       setIsLogin(true);
  //     })
  //     .catch((err) => {
  //       // console.error(err);
  //     });
  // }, []);

  useEffect(() => {
    CoursesService.getAllCourses()
      .then((response) => response.json())
      .then((data) => {
        const allCourses = data?.course?.course;

        // Specify the IDs for the courses you want to prioritize (programming, DS, DBMS)
        const programmingCourseIds = [47, 57, 58, 83, 84, 85]; // Example course IDs for programming courses
        const dataStructureCourseId = 69; // ID for Data Structure and Algorithms
        const dbmsCourseId = 86; // ID for Database Management System

        // Separate courses based on priority
        const programmingCourses = allCourses.filter(course => programmingCourseIds.includes(course.course_id));
        const dataStructureCourse = allCourses.filter(course => course.course_id === dataStructureCourseId);
        const dbmsCourse = allCourses.filter(course => course.course_id === dbmsCourseId);

        // Remaining courses
        const otherCourses = allCourses.filter(course => 
          !programmingCourseIds.includes(course.course_id) &&
          course.course_id !== dataStructureCourseId &&
          course.course_id !== dbmsCourseId
        );

        // Combine in the desired order: Programming -> DS -> DBMS -> Other
        const sortedCourses = [
          ...programmingCourses,
          ...dataStructureCourse,
          ...dbmsCourse,
          ...otherCourses
        ];

        setCourses(sortedCourses);
        setIsLogin(true);
      })
      .catch((err) => {
        // console.error(err);
      });
  }, []);


  const location = useLocation();
  const isNestedRoute =
    location.pathname.startsWith("/course/") && location.pathname !== "/course";


  if (isNestedRoute) {
    return (
      <>
    
        <Outlet />
      </>
    );
  }

  return (
    <div>
      <div className="container mt-lg-5">
        {/* <div className="text-center mt-3 mb-5">
          <h3>Select Your Skill</h3>
        </div> */}
<div className="d-flex align-items-center justify-content-between mb-5 mt-5">
          <button
            className="btn bk-adm back-button"
            onClick={() => navigate(-1)}
          >
            Back
          </button>
         <div className="mt-0 mb-0 text-center flex-grow-1">
         
         <h3>Select Your Skill</h3>
         </div>
        </div>

        <div className="row">
          {courses?.map((cour, index) => (
            <CourseItem key={index} course={cour} />
          ))}
        </div>
      </div>

      <Outlet />
    </div>
  );
};

export default Courses;
